import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { grochatWebsocketUrl } from './config/serviceConfig';
import { closeGrochatWebsocketConnection, createGrochatWebsocketConnection } from './redux/action/grochatWebsocketAction';
import { ROUTER_CONSTANT } from './constants/routerConstant';
import ForceLogout from './components/Common/ForceLogout';
import Sidebar from './components/Sidebar/Sidebar';
import Topbar from './components/Topbar/Topbar';
import FloatingButton from './components/Chat/FloatingButton';
import CallWindow from './components/Call/CallWindow';
import { useContext } from 'react';
import { GroChatVoipContext } from './components/GroChatVoipProvider/GroChatVoipProvider';
// import GroChatVoipProvider from './components/GroChatVoipProvider/GroChatVoipProvider';
// import { RTCConfig } from './config/voipConfig';
// import ringingSound from './assets/audios/phone-calling.mp3';
// import hangUpSound from './assets/audios/hang-up.mp3';

export default function ProtectedRoute({ component: Component, ...rest }) {
    const login = useSelector(state => state.authentication.login);
    const token = useSelector(state => state.authentication.token);
    const tncAccepted = useSelector(state => state.authentication.tncAccepted);
    const authentication = useSelector(state => state.authentication);
    const websocket = useSelector(state => state.grochatWebsocket.websocket);
    const dispatch = useDispatch();
    const groChatVoipContext = useContext(GroChatVoipContext)

    useEffect(() => {
        connectWebsocket(dispatch, websocket);
        initiateListener(dispatch, websocket, authentication);
        closeWebsocket(dispatch, websocket, authentication, groChatVoipContext);
    }, [dispatch, websocket, authentication, groChatVoipContext])

    return (
        <Route
            {...rest}
            render={props => {
                if (!login || token === null) {
                    return <Redirect to={{ pathname: ROUTER_CONSTANT.LOGIN }} />
                }

                if (tncAccepted === false) {
                    return <Redirect to={{ pathname: ROUTER_CONSTANT.LOGIN }} />
                }

                if (login && token !== null) {
                    return <>
                        <Topbar />
                        <div className="container-layout">
                            <ForceLogout />
                            <Sidebar />
                            <div className="main-layout px-10 overflow-auto">
                                <Component {...props} />
                            </div>
                        </div>
                        {
                            localStorage.getItem('loginWithGrochatAccount') === 'true' && (
                                <>
                                    <CallWindow clientId={authentication.userDetail.client_id} />
                                    <FloatingButton />
                                </>
                            )
                        }
                    </>
                }
            }}
        />
    )
}

const websocketHandshake = (websocket, authentication) => {
    const data = {
        client_id: authentication.userDetail.client_id,
        token: authentication.token,
        sign: authentication.sign
    }
    websocket.send(JSON.stringify(data));
}

const initiateListener = (dispatch, websocket, authentication) => {
    if (websocket && localStorage.getItem('loginWithGrochatAccount') === 'true') {
        websocket.addEventListener('open', event => {
            console.log('WebSocket connection is now OPEN.');
            websocketHandshake(websocket, authentication);
        })

        websocket.addEventListener('message', event => {
            // console.log('Message received:', event.data);
        })

        websocket.addEventListener('error', event => {
            // console.error('WebSocket error:', event);
        })

        websocket.addEventListener('close', event => {
            if (event.code === 1005) {
                return
            }
            console.log('WebSocket connection is now CLOSED.');
            reconnectWebsocket(dispatch, websocket, authentication);
        })
    }
}

const connectWebsocket = (dispatch, websocket) => {
    if (!websocket) {
        const websocketConnection = new WebSocket(grochatWebsocketUrl);
        dispatch(createGrochatWebsocketConnection(websocketConnection));
    }
};

/**
 * @param {React.ContextType<GroChatVoipContext>} groChatVoipContext 
 */
const closeWebsocket = async (dispatch, websocket, authentication, groChatVoipContext) => {
    if (!authentication.login || !authentication.token) {
        await groChatVoipContext.hangUp()
        
        websocket?.close();
        dispatch(closeGrochatWebsocketConnection());
    }
};

const reconnectWebsocket = (dispatch, websocket, authentication) => {
    console.log('WebSocket connection is now CONNECTING.');
    setTimeout(() => {
        connectWebsocket(dispatch);
        initiateListener(dispatch, websocket, authentication);
    }, 3000);
};
